import moment from "moment";

export const predefinedRanges = {
    ['Today']: [moment(), moment()],
    ['Yesterday']: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    ['Last week']: [moment().subtract(1, "week").startOf("week"), moment().subtract(1, "week").endOf("week")],
    ['This week']: [moment().startOf('week'), moment()],
    ['This month']: [moment().startOf("month"), moment()],
    ['Last month']: [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")],
    ['Last year']: [moment().subtract(1, "year").startOf("year"), moment().subtract(1, "year").endOf("year")],
};